import React from 'react'

const Info = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g>
        <path
          d='M12 6.5386C12.1743 6.5386 12.3205 6.4796 12.4385 6.3616C12.5565 6.2436 12.6155 6.09743 12.6155 5.9231C12.6155 5.74876 12.5565 5.6026 12.4385 5.4846C12.3205 5.3666 12.1743 5.3076 12 5.3076C11.8257 5.3076 11.6795 5.3666 11.5615 5.4846C11.4435 5.6026 11.3845 5.74876 11.3845 5.9231C11.3845 6.09743 11.4435 6.2436 11.5615 6.3616C11.6795 6.4796 11.8257 6.5386 12 6.5386ZM11.5 14.3461H12.5V8.26935H11.5V14.3461ZM3 20.0001V2.9231H21V16.9231H6.077L3 20.0001ZM5.65 15.9231H20V3.9231H4V17.5673L5.65 15.9231Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export default Info
